import styled from 'styled-components';

export const CountdownSettingsStyled = styled.div`
  .Polaris-Choice {
    width: 100%;
    &__Label {
      width: 100%;
    }
  }
  .Polaris-ChoiceList__ChoiceChildren {
    .Polaris-Choice {
      width: auto;
      &__Label {
        width: auto;
      }
    }
  }
  .Polaris-Select {
    &:has(#countdown_timer_option_select_box) {
      max-width: 160px;
    }
    &:has(#session-behavior-select-box) {
      @media (max-width: 576px) {
        max-width: 160px;
      }
    }
  }
  .fixed-time-label {
    min-width: 110px;
  }
  .inline-select-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    &__sub-item {
      margin-left: 118px;
      @media (max-width: 1040px) {
        margin-left: 46px;
      }
      @media (max-width: 576px) {
        margin-left: 0;
      }
    }
  }
  .Polaris-ChoiceList__ChoiceChildren {
    .Polaris-Box {
      padding-top: 0;
    }
  }
  .Polaris-Select {
    @media (max-width: 375px) {
      &:has(#session-behavior-select-box) {
        max-width: 160px;
      }
      &:has(#end-behavior-select-box) {
        max-width: 160px;
      }
    }
  }
`;
